import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { purchaseAPI } from '../api';

export default function TicketPage() {
  const { code } = useParams();
  const [purchase, setPurchase] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    purchaseAPI.verify(code).then(r => setPurchase(r.data.purchase)).finally(() => setLoading(false));
  }, [code]);

  if (loading) return <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>Loading ticket...</div>;
  if (!purchase) return <div style={{ textAlign: 'center', padding: 60 }}><h2>Ticket not found</h2><Link to="/">← Back to events</Link></div>;

  const whatsappText = encodeURIComponent(`My ticket for ${purchase.event_name}: https://tikoo.omogusiiwarriors.org/ticket/${code}`);

  return (
    <div style={{ minHeight: '100vh', background: '#f8f9fa', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
      <div style={{ background: '#fff', borderRadius: 20, maxWidth: 440, width: '100%', overflow: 'hidden', boxShadow: '0 8px 40px rgba(0,0,0,0.12)' }}>
        {/* Header */}
        <div style={{ background: '#1A2744', padding: 24, textAlign: 'center' }}>
          <img src="https://omogusiiwarriors.org/icons/logo.png" alt="OWW" style={{ width: 50, height: 50, objectFit: 'contain', marginBottom: 8 }} />
          <div style={{ color: '#fff', fontFamily: "'Playfair Display', serif", fontSize: 20 }}>🎟️ Your Ticket</div>
        </div>

        {/* Event Info */}
        <div style={{ background: '#f0fdf4', padding: 20, textAlign: 'center', borderBottom: '2px dashed #E5E7EB' }}>
          <h2 style={{ fontFamily: "'Playfair Display', serif", color: '#1A2744', margin: '0 0 8px', fontSize: 22 }}>{purchase.event_name}</h2>
          <div style={{ color: '#6B7280', fontSize: 14 }}>📅 {new Date(purchase.date).toLocaleDateString('en-KE', { dateStyle: 'full' })}</div>
          <div style={{ color: '#6B7280', fontSize: 14 }}>⏰ {purchase.time} · 📍 {purchase.venue}</div>
        </div>

        {/* Ticket Details */}
        <div style={{ padding: 24 }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: 20 }}>
            {[
              ['Ticket Holder', purchase.buyer_name],
              ['Ticket Type', purchase.ticket_type_name],
              ['Quantity', purchase.quantity],
              ['Amount Paid', `KSh ${purchase.total_amount.toLocaleString()}`],
              purchase.member_number ? ['Member #', purchase.member_number] : null,
              purchase.buyer_id_number ? ['ID Number', purchase.buyer_id_number] : null,
            ].filter(Boolean).map(([label, value]) => (
              <tr key={label}>
                <td style={{ padding: '6px 0', color: '#9CA3AF', fontSize: 13 }}>{label}</td>
                <td style={{ padding: '6px 0', fontWeight: 600, textAlign: 'right', fontSize: 13 }}>{value}</td>
              </tr>
            ))}
          </table>

          {/* Ticket Code */}
          <div style={{ border: '2px dashed #E5E7EB', borderRadius: 10, padding: 16, textAlign: 'center', marginBottom: 20 }}>
            <div style={{ fontSize: 11, color: '#9CA3AF', marginBottom: 6, letterSpacing: 2 }}>TICKET CODE</div>
            <div style={{ fontSize: 20, fontWeight: 800, color: '#E8521A', letterSpacing: 3 }}>{purchase.ticket_code}</div>
            <div style={{ fontSize: 11, color: '#9CA3AF', marginTop: 6 }}>Show this at the entrance</div>
          </div>

          {/* Actions */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            <button onClick={() => window.print()}
              style={{ padding: '12px', background: '#1A2744', color: '#fff', border: 'none', borderRadius: 8, fontWeight: 700, cursor: 'pointer', fontSize: 14 }}>
              🖨️ Print / Download Ticket
            </button>
            <a href={`https://wa.me/?text=${whatsappText}`} target="_blank" rel="noopener noreferrer"
              style={{ padding: '12px', background: '#25D366', color: '#fff', border: 'none', borderRadius: 8, fontWeight: 700, cursor: 'pointer', fontSize: 14, textAlign: 'center', display: 'block' }}>
              📱 Share on WhatsApp
            </a>
            <Link to="/" style={{ padding: '12px', background: '#f3f4f6', color: '#374151', border: 'none', borderRadius: 8, fontWeight: 600, fontSize: 14, textAlign: 'center', display: 'block' }}>
              ← Browse More Events
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
